module.exports = __webpack_public_path__ + "static/toyota-5b29325489224e919ca62b5848f64203.png";